(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('book-gift-message')) {
  customElements.define('book-gift-message', class extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('input[type="checkbox"]');
      const fields = this.querySelector('.book-gift-message__fields');
      const message = this.querySelector('textarea');
      const sync = () => {
        fields.hidden = !toggle.checked;
        message.disabled = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
      };
      toggle.addEventListener('change', sync);
      sync();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
